import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [RiskLevel.Low, [{ lower: 1.5, upper: 20 }]],
      [RiskLevel.Medium, [{ lower: 1.3, upper: 1.5 }]],
      [RiskLevel.High, [{ lower: 0, upper: 1.3 }]],
    ]),
  ],
]);

export default referenceRange;
